import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import { getlang } from 'src/helper/getlang'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.serviceStore = this.props.store.register('app/service')
  }
  state = {
    lang: lang.ar,
    language:'en',
  }

  async componentWillMount() {
    console.log('componentWillMount')
    let language =await getlang()
    // language = 'ar'
    switch (language) {
      case 'ar':
        this.setState({
          lang: lang.ar
        })
        break
      case 'tr':
        this.setState({
          lang: lang.tr
        })
        break
      default:
        this.setState({
          lang: lang.en
        })
        break
    }
  }

  async componentDidMount() {
    console.log('componentDidMount')
    setDocumentTitle(this.state.lang.title)
    window.scroll(0, 0)
  }

  faqContent = (faq) => {
    return (
      <div className="faqContent">
        <div className="title" dangerouslySetInnerHTML={{ __html: faq.question || '' }}></div>
        <div className="content" dangerouslySetInnerHTML={{ __html: faq.answer || '' }}></div>
      </div>
    )
  }

  render() {
    let language = this.state.language
    // language = 'ar'
    let data = this.serviceStore.data
    let { faqContent } = data
    return <div className={`service ${language == 'ar' && 'arlang'}`}>{this.faqContent(faqContent)}</div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/faqContent.js